import { Card, CardBody, CardHeader, Heading, Skeleton } from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

import { useGetWalletQuery } from '@blockpulse3/graphql/hooks';
import { ErrorQueryCard } from '@blockpulse3/ui/commons';

import { WalletTable } from './WalletTable';
import { useIdentityId } from './useIdentityId';

type Props = unknown;

/**
 * Wallet.
 *
 * @returns {JSX.Element}
 */
export function Wallet(): JSX.Element | null {
  const i18nWallet = useTranslations('Wallet');

  const identityId = useIdentityId();

  const { data, loading, error } = useGetWalletQuery({
    variables: {
      identityId: identityId || '',
    },
    skip: !identityId,
  });

  if (loading || !identityId) {
    return (
      <Skeleton>
        <Card height="290px" />
      </Skeleton>
    );
  }

  if (error) {
    return <ErrorQueryCard />;
  }

  const walletBalances = data?.getWallet?.balances || [];

  if (!walletBalances?.length) return null;

  return (
    <Card>
      <CardHeader>
        <Heading size="md">{i18nWallet('Title')}</Heading>
      </CardHeader>
      <CardBody>
        <WalletTable balances={walletBalances} />
      </CardBody>
    </Card>
  );
}

export type WalletProps = Props;
